<template>
  <section v-on:click="sectionClicked" class="features twoImage" :class="section.id">
    <div class="cnt">
      <div class="twoImg-cnt" v-if="section.items.length > 0">
        <div class="twoImg-item" v-for="(item, i) in section.items" :key="i"
          :class="{video: item.media[lang] && item.media[lang].type === 'video'}">
          <div class="twoImg-img noImg" v-if="!item.media[lang]"></div>
          <div class="twoImg-img video" v-else-if="item.media[lang].type === 'video'"
            :style="{'background-image': `url(${item.media[lang].mainThumb})`}"
            v-on:click="openVideo(item)"></div>
          <div class="twoImg-img image" :class="item.bgSize" v-else
            :style="{'background-image': `url(${item.media[lang].imageSm})`}"></div>
          <h4 v-if="item.title[lang]">{{item.title[lang]}}</h4>
          <p v-if="item.descriptions[lang]" v-html="item.descriptions[lang]"></p>
          <a :href="`${(item.url.substring(0,1) === '/') ? `/${langCode}${item.url}` : item.url}`"
            class="btn btnPrimary" v-if="item.buttonLabel[lang]" target="_blank">{{item.buttonLabel[lang]}}</a>
        </div>
      </div>
      <div class="twoImg-cnt placeholder" v-else>
        <div class="twoImg-item">
          <div class="twoImg-img noImg"></div>
        </div>
        <div class="twoImg-item">
          <div class="twoImg-img noImg"></div>
        </div>
      </div>
    </div>
    <!-- <VideoDialogLocal ref="videoDialogLocal"/> -->
  </section>
</template>

<script>
// import VideoDialogLocal from '@/components/VideoDialogLocal.vue';

export default {
  name: 'home',
  props: ['section'],
  // components: { VideoDialogLocal },
  data() {
    return {
      /**
       * Language
       *
       */
      langCode: 'id-id',
      lang: 'id',
    };
  },
  methods: {
    doNothing() {},
    sectionClicked() {},
    openVideo(item) {
      this.section.modalOpen = true;
      this.$refs.videoDialogLocal.open(item, () => {
        this.section.modalOpen = false;
      });
    },
  },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';
  },
};
</script>

<style scoped lang="scss">
.twoImg-cnt{
  max-width: 1260px;
  margin: 0 auto;
  display: flex;
  &.placeholder{
    margin-bottom: -20px;
  }
  .twoImg-item{
    text-align: center;
    width: 50%;
    box-sizing: border-box;
    padding: 0 60px;
    @media (max-width: 940px) {
      width: auto;
      margin: 0 0 100px;
    }
    @media (max-width: 680px) {
      padding: 0;
    }
    &:last-child{
      margin: 0;
    }
    h4{
      margin: 0 0 6px;
      font-size: 24px;
      font-weight: 600;
    }
    p{
      font-size: 16px;
      margin: 0 0 20px;
      line-height: 1.3;
    }
    .twoImg-img{
      margin: 0 0 20px;
      border-radius: 5px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      &.video{
        height: 240px;
        transition: all .3s ease;
        position: relative;
        cursor: pointer;
        @media (max-width: 1240px) {
          height: 260px;
        }
        @media (max-width: 940px) {
          height: 46vw;
        }
        &:before{
          content: "";
          position: absolute;
          left: 50%; top: 50%;
          width: 54px; height: 54px;
          margin: -27px 0 0 -27px;
          border: #fff 2px solid;
          border-radius: 50%;
          background-image: url(../../assets/play-white.png);
          background-size: 26px auto;
          background-position: 15px 50%;
          background-repeat: no-repeat;
          opacity: .3;
          transition: all .3s ease;
        }
        &:hover{
          box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
          &:before{
            opacity: .7;
          }
        }
      }
      &.noImg{
        height: 240px;
        background-color: #ccc;
        background-image: url(../../assets/image-black.png);
        background-size: 46px auto;
        transition: all .3s ease;
        position: relative;
        opacity: .3;
      }
      &.image{
        height: 240px;
        &.contain{
          background-size: contain;
        }
      }
    }
    .btn{
      border-radius: 50px;
      display: inline-block;
      width: auto;
      font-weight: 600;
    }
    &.video{
      padding: 0 60px;
      @media (max-width: 680px) {
        padding: 0;
      }
      h4{
        font-size: 20px;
      }
    }
  }
}
</style>
